module.exports = __webpack_public_path__ + "europa-10_emerald_number.jpg?f6030003b6c3745c34a9021caa2847e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-10_emerald_number.jpg
// module id = 280
// module chunks = 0